export const userRoles = [
  {
    id: 'productionLines',
    name: 'Production Lines',
    roles: [
      {
        id: 'startBatch',
        label: 'Start Batch',
        users: ['Planning Admin'],
      },
      {
        id: 'wipIssue',
        label: 'WIP Issue',
        users: ['Planning Admin'],
      },
      {
        id: 'wipComplete',
        label: 'WIP Complete',
        users: ['Planning Admin'],
      },
      {
        id: 'productionComplete',
        label: 'Production Complete',
        users: ['Planning Admin'],
      },
      {
        id: 'closeBatch',
        label: 'Close Batch',
        users: ['Planning Admin'],
      },
      {
        id: 'batchReturns',
        label: 'Batch Returns',
        users: ['Planning Admin'],
      },
      {
        id: 'liveBatchTicket',
        label: 'Live Batch Ticket',
        users: ['Planning Admin'],
      },
    ],
  },
  {
    id: 'miscellaneous',
    name: 'Miscellaneous',
    roles: [
      {
        id: 'reprintLpnLabel',
        label: 'Reprint LPN Label',
        users: ['Planning Admin', 'Planning'],
      },
      {
        id: 'eventsLog',
        label: 'Events Log',
        users: ['Planning Admin', 'Planning'],
      },
      {
        id: 'userAdmin',
        label: 'User Admin',
        users: ['Master Data'],
      },
    ],
  },
  {
    id: 'planning',
    name: 'Planning',
    roles: [
      {
        id: 'wipCompleteFG',
        label: 'Wip Complete (FG)',
        users: ['Planning'],
      },
      {
        id: 'batchReturnsFG',
        label: 'BatchReturns (FG)',
        users: ['Planning'],
      },
    ],
  },
];
